jQuery( document ).ready( function() {
	let paged = 1;
	// Pagination
	function blogPagination() {
		jQuery( '.blog-pagination-btn' ).on( 'click', 'button[data-page]', function( e ) {
			e.preventDefault();
			paged = jQuery( this ).data( 'page' );
			console.log( paged );
			if ( paged ) {
				sendAjaxRequest();

				const targetY = jQuery( 'body' ).hasClass( 'logged-in' )
					? jQuery( '#blogpage' ).offset().top - 280
					: jQuery( '#blogpage' ).offset().top - 260;

				jQuery( 'html, body' ).animate( { scrollTop: targetY } );
			}
		} );
	}
	blogPagination();

	function sendAjaxRequest() {
		jQuery( '.loader-container' ).show();

		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'posts_filter',
				paged,

			},
			success( response ) {
				jQuery( '.loader-container' ).hide();
				console.log( 'AJAX Success:', response );
				jQuery( '#posts-container' ).html( response.html );
				jQuery( '#ajax-blog-pagination' ).html( response.pagination );
				blogPagination();
			},
			error( xhr, status, error ) {
				jQuery( '.loader-container' ).hide();
				console.error( 'AJAX Error:', error );
				console.log( 'Full Response:', xhr.responseText );
				alert( 'Something went wrong. Please try again.' );
			},
		} );
	}
} );
